import { useCallback } from 'react';
import { prop } from 'js/utils/ramda.util';
import { useFormatter } from 'js/hooks/useFormatter';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import { useDynamicReducerSelector } from '../../../store';

export const useGetExportSportsbookHistory = () => {
    const formatter = useFormatter();
    const translate = useComponentTranslations();
    const defaultTypeNames = useDynamicReducerSelector(prop('defaultTypeNames'));

    return useCallback(transactions => transactions.map(transaction => {
        const {
            transactionDateInUms, actionType, balanceChanges = [], transactionCodeInUms, clientType,
            amount: { amount, currencyCode }
        } = transaction;
        const balanceAfter = balanceChanges.find(item => item.balanceType === 'sportsbook_gaming_balance')?.balanceAfter || {};
        const endBalance = balanceAfter.amount
            && formatter.formatCurrency(balanceAfter.amount, { currencyCode: balanceAfter.currencyCode });
        const formattedAmount = currencyCode === 'XXX'
            ? `${amount} ${translate(`transaction.freeSpins.${Math.abs(amount) > 1 ? 'many' : 'one'}`)}`
            : formatter.formatCurrency(amount, { currencyCode });

        return {
            [translate('column.title.date')]: formatter.getDateTimeShort(formatter.parseImsDate(transactionDateInUms)),
            [translate('column.title.name')]: defaultTypeNames[actionType],
            [translate('column.title.amount')]: formattedAmount,
            ...endBalance && { [translate('column.title.balance')]: endBalance },
            [translate('transaction.id')]: transactionCodeInUms,
            [translate('transaction.product')]: clientType
        };
    }), [formatter, translate, defaultTypeNames]);
};
